import { connect } from 'react-redux';
import { setFlatIdAction, setHoveredFlatIdAction } from '../actions/mvk_state';
import { FloorScheme } from '../components/floor_scheme';
import { getFlatsBySectionFilters } from '../utils/parsers/flats';
import { getFloorScheme } from '../utils/parsers/sections';
function mapStateToProps(state) {
  var MVKData = state.MVKData,
    _state$MVKState = state.MVKState,
    flat = _state$MVKState.flat,
    house = _state$MVKState.house,
    isFullScreen = _state$MVKState.isFullScreen,
    isOfferCard = _state$MVKState.isOfferCard,
    phase = _state$MVKState.phase,
    section = _state$MVKState.section,
    sectionPhaseFilters = _state$MVKState.sectionPhaseFilters;
  return {
    currentPhase: phase,
    floorFlats: getFlatsBySectionFilters(MVKData, sectionPhaseFilters, house.id, section.id),
    floorScheme: getFloorScheme(MVKData, house.id, section.id, sectionPhaseFilters.selectedFloor),
    hoveredFlatId: flat.hoveredId,
    isFullScreen: isFullScreen,
    isOfferCard: isOfferCard
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setFlatId: function setFlatId(flatId) {
      return dispatch(setFlatIdAction(flatId));
    },
    setHoveredFlatId: function setHoveredFlatId(flatId) {
      return dispatch(setHoveredFlatIdAction(flatId));
    }
  };
}
export var FloorSchemeContainer = connect(mapStateToProps, mapDispatchToProps)(FloorScheme);